import { Button } from '@heroui/react';
import { FC } from 'react';

import AccessIcon from '../../assets/icons/access.svg?url';
import { useAuthState } from '../../state';
import {
  AccessDeniedContainer,
  AccessDeniedWrapper,
  ContentWrapper,
  Description,
  Title,
} from './AccessDenied.styled';

interface AccessDeniedProps {
  isLoading?: boolean;
}
export const AccessDenied: FC<AccessDeniedProps> = () => {
  const { logout, currentUser } = useAuthState();
  return (
    <AccessDeniedWrapper>
      <AccessDeniedContainer>
        <ContentWrapper>
          <img src={AccessIcon} alt="access denied" />
          <Title>Access denied</Title>
          <Description>
            Twoje konto
            <strong>{ currentUser?.email}</strong>
            <br />
            nie ma uprawnień do tej aplikacji.
          </Description>
          <Button onClick={logout} size="sm" color="danger" className="mt-5">
            Wyloguj się
          </Button>
        </ContentWrapper>
      </AccessDeniedContainer>
    </AccessDeniedWrapper>

  );
};
